import React, { useMemo } from 'react';
import FocusTrap from 'focus-trap-react';
import { VenueWithMenus } from 'components/SingleItem/Details';
import useFeatureFlagsQuery from 'common/Hooks/UseFeatureFlagsQuery';
import Surcharge from 'components/Surcharge/Surcharge';

interface Props {
  currentVenue?: VenueWithMenus | undefined;
  incrementMenuSurchargePublishCount: () => void;
}

const SURCHARGE_FEATURE_FLAG = 'surchargeEnabled';

const SurchargePanel: React.FC<Props> = ({ currentVenue, incrementMenuSurchargePublishCount }) => {
  const [data, loading, error] = useFeatureFlagsQuery([SURCHARGE_FEATURE_FLAG]);
  const isSurchargeEnabled = useMemo(() => {
    if (loading || error || !data) {
      return false;
    }

    const surchargeFeatureFlag = data[SURCHARGE_FEATURE_FLAG];
    return surchargeFeatureFlag ? surchargeFeatureFlag.isEnabled : false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      {isSurchargeEnabled && (
        <FocusTrap
          active
          focusTrapOptions={{
            escapeDeactivates: false,
            clickOutsideDeactivates: true
          }}
        >
          <Surcharge
            menus={currentVenue?.menus}
            venueId={currentVenue?.hashedId}
            venueName={currentVenue?.name}
            incrementMenuSurchargePublishCount={incrementMenuSurchargePublishCount}
          />
        </FocusTrap>
      )}
    </div>
  );
};

export default SurchargePanel;
